<section class="login-wrapper container-fluid">
  <img [src]='environment1 + "assets/images/Square T.svg"' class="t-image" alt="T">
  <div class="horizontal-line"></div>
  <div class="vertical-line"></div>
  <div class="bottom-horizontal-line"></div>
  <div class="bottom-vertical-line"></div>
  <div class="row">

      <div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7 order-1 login-banner p-0">
          <section class="banner-carousel">
              <div id="bannerCarousel" class="bannerCarousel">
                  <ng-container *ngIf="!isLoading; else loadingContent">
                      <ngx-skeleton height="570px"></ngx-skeleton>
                  </ng-container>
                  <ng-template #loadingContent>
                      <owl-carousel-o [options]="customOptionsForBanner">
                          <ng-container carouselSlide>
                              <a>
                                  <div class="top-banner-wrapper">
                                      <div class="t-shape">
                                          <!-- <img src="../../../../assets/images/Square T.svg" alt=""> -->

                                      </div>

<!--
                                      <div class="horizontal-line" style=" margin-top: -118px;margin-left: 92px;position: fixed;">
                                          <svg width="1440" height="550" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="0" y="0" width="1500" height="4" fill="#307FE2" />
                                          </svg>
                                        </div>
                                        <div class="middle-line">
                                          <svg width="1440" height="490.5" xmlns="http://www.w3.org/2000/svg" style="margin-right: 14px;margin-left: 90px;margin-top: -116px; position: fixed;">
                                            <rect x="0" y="0" width="4" height="118" fill="#307FE2" />
                                          </svg>
                                        </div>
                                        <div class="verticle-line" style=" margin-left: 57px;margin-top: -2px;position: fixed;">
                                          <svg width="1440" height="540" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="0" y="0" width="4" height="540" fill="#307FE2" />
                                            <rect x="0" y="0" width="37" height="4" fill="#307FE2" />
                                          </svg>
                                        </div> -->
                                  </div>

                              </a>
                          </ng-container>
                      </owl-carousel-o>
                  </ng-template>
              </div>
          </section>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5 order-2 login-content p-4">
          <div class="login-header d-lg-flex">
              <div class="header-logo">
                  <a href="https://www.tatamotors.com/" target="_blank" rel="noopener noreferrer" class="d-inline-block">
                    <img  class="svg" [src]='environment1 + "assets/images/better_alway_black.png"' />
                  </a>
                  <a class="navbar-brand align-items-center" href="">
                      <span ><img class="OSP-text" [src]='environment1 + "assets/images/osp_logo_dark.png"'></span>
                  </a>
              </div>
              <div class="tata-logo ms-auto">
                  <a href="https://www.tata.com/" target="_blank" rel="noopener noreferrer" class="d-inline-block">
                      <img  class="svg1" [src]='environment1 + "assets/images/Tata-Logo.png"' alt="tata" loading="lazy" style="margin-top: -10px;">
                  </a>
              </div>
          </div>
          <section *ngIf="isshowLogin">
              <form [formGroup]="LoginFormGroup">
                  <h1 class="mobilmargin">Welcome to Fleet Verse</h1>
                  <div class="welcome-text mobilmargin">
                      Please enter your 10-digit mobile number so that we can serve you better with on-site search,
                      product recommendations and seamless support through your purchase journey with Tata Motors Fleet Verse.
                      You can also view your order status post booking once you log in next on Fleet Verse.
                  </div>
                  <div class="mb-4 mobilmargin">
                      <label class="form-label">Enter your mobile number</label>
                      <div class="form-input">
                          <div class="country-code">
                              <div class="nation-flag">
                                  <img alt="Nation Flag" [src]='environment1 + "assets/images/ind-flag.svg"' class="img-fluid" loading="lazy" />
                              </div>
                              +91
                          </div>
                          <input formControlName="mobileNo" type="tel" (keyup)="checkValue($event.target)" class="mobile_no"
                              maxlength="10" placeholder="Mobile Number" numbersOnly (keypress)="onlyNumberKey($event)"
                              (keyup.enter)="sentOtp()" />
                      </div>
                      <div class="error-message" *ngIf="hasRequiredError('mobileNo')">
                          *Required
                      </div>
                      <div class="error-message" *ngIf="hasPatternError('mobileNo')">
                          *Invalid Mobile No.
                      </div>
                  </div>
                  <div class="d-flex mobilmargin">
                      <input class="form-check-input mb-1" style="border: 1px solid black;" type="checkbox" value="" #myloginCheckbox (change)="onCheckboxChangelogin(myloginCheckbox.checked)" id="flexCheckDefaultlogin">
                      <label class="form-check-label ms-3" for="flexCheckDefaultlogin"></label>
                      <div class="t-c mt-1">
                          By continuing, you agree to <a (click)="gotoPath('/terms-conditions')">T&C</a> & <a (click)="gotoPath('/privacy-policy')">Privacy Policy</a>
                      </div>
                  </div>
                  <div class="mb-2 mt-2 mobilmargin">
                      <button [ngClass]="{'disabled': !checkBoxchekedlogin}" class="btn btn-primary btn-lg btn-grad-primary btn-brand w-100" (click)=" sentOtp()"
                          data-toggle="tooltip" data-placement="top" title="Click here to Get Code"
                          [disabled]="LoginFormGroup.invalid">Get Code</button>
                  </div>
                  <div class="l-c mt-1 mobilmargin">
                      By continuing to use this website/App, you are accepting the Privacy Policy,
                      Disclaimers and other Website Policies of Tata Motors Limited. The
                      information collected would be used to improve your web journey and to
                      personalize your website experience. The data/ information so collected shall
                      be stored, processed, utilized, transferred and used for promotional and
                      marketing activities.
                  </div>
              </form>
          </section>
          <section *ngIf="isshowOtp">
              <app-otp (loadParent)="showLogin()" (loadSignup)="showSignup()"></app-otp>
          </section>
          <section *ngIf="isshowSignUp">
              <app-signup (loadParent)="showLogin()" (loadOtpParent)="showOtp()"></app-signup>
          </section>
      </div>
  </div>
</section>
